import { createSlice } from '@reduxjs/toolkit';
import { IInitialToolsData } from './types';

const SLICE_NAME = 'TOOLS_LEVEL_SLICE';

export const initialState: IInitialToolsData = {
    upalodImagekey:'',
    loadingupalodImage:false,
    upalodImageError:'',

    generateDescriptionData:'',
    loadinggenerateDescription:false,
    generateDescriptionError:'',

    checkImageDescriptionData:'',
    loadingcheckImageDescription:false,
    checkImageDescriptionError:'',

    getWebsiteContextData:'',
    loadinggetWebsiteContext:false,
    getWebsiteContextError:'',


    auditSinglePageData:'',
    loadingauditSinglePage:false,
    auditSinglePageError:'',

    auditCodeSnippetData:'',
    loadingauditCodeSnippet:false,
    auditCodeSnippetError:'',

    languageLevelCheckerData:'',
    loadinglanguageLevelChecker:false,
    languageLevelCheckerError:'',

    singlePagesData:'',
    loadingsinglePagesData:false,
    singlePagesDataError:'',

    singlePageAudit:'',
    loadingsinglePageAudit:false,
    singlePageAuditError:'',


    codeSnippetCheckerData:'',
    loadingcodeSnippetCheckerData:false,
    codeSnippetCheckerDataError:'',

    codeSnippetChecker:'',
    loadingcodeSnippetChecker:false,
    codeSnippetCheckerError:'',
};

const toolsSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    upalodImageError: (state, { payload }) => {
        state.loadingupalodImage = false;
        state.upalodImagekey = '';
        state.upalodImageError = payload;
        state.generateDescriptionError = '';
        state.checkImageDescriptionError = '';
        state.getWebsiteContextError=''


    },
    upalodImage: (state, { payload }) => {
        state.checkImageDescriptionData = '';
        state.generateDescriptionData = '';
        state.loadingupalodImage = true;
        state.upalodImageError = '';
      },
    upalodImageSuccess: (state, { payload }) => {
        state.loadingupalodImage = false;
        state.upalodImagekey = payload;
    },

    generateDescriptionError: (state, { payload }) => {
        state.loadinggenerateDescription = false;
        state.generateDescriptionData = '';
        state.generateDescriptionError = payload;
        state.getWebsiteContextError=''
        state.upalodImageError = '';
        state.checkImageDescriptionError = '';
    },
    generateDescription: (state, { payload }) => {
        state.loadinggenerateDescription = true;
        state.generateDescriptionError = '';
      },
    generateDescriptionSuccess: (state, { payload }) => {
        state.loadinggenerateDescription = false;
        state.generateDescriptionData = payload;
    },
  

    checkImageDescriptionError: (state, { payload }) => {
        state.loadingcheckImageDescription = false;
        state.checkImageDescriptionData = '';
        state.checkImageDescriptionError = payload;
        state.generateDescriptionError = '';
        state.upalodImageError = '';
        state.getWebsiteContextError=''
    },
    checkImageDescription: (state, { payload }) => {
        state.loadingcheckImageDescription = true;
        state.checkImageDescriptionError = '';
      },
    checkImageDescriptionSuccess: (state, { payload }) => {
        state.loadingcheckImageDescription = false;
        state.checkImageDescriptionData = payload;
    },
    
    getWebsiteContextError: (state, { payload }) => {
        state.loadinggetWebsiteContext = false;
        state.getWebsiteContextError = payload;
        state.checkImageDescriptionError = '';
        state.generateDescriptionError = '';
        state.upalodImageError = '';
    },
    getWebsiteContext: (state, { payload }) => {
        state.loadinggetWebsiteContext = true;
        state.getWebsiteContextError = '';
    },
    getWebsiteContextSuccess: (state, { payload }) => {
        state.loadinggetWebsiteContext = false;
        state.getWebsiteContextData = payload;
    },

    auditSinglePageError: (state, { payload }) => {
        state.loadingauditSinglePage = false;
        state.auditSinglePageError = payload;
    },
    auditSinglePage: (state, { payload }) => {
        state.loadingauditSinglePage = true;
        state.auditSinglePageError = '';
    }, 
    auditSinglePageSuccess: (state, { payload }) => {
        state.loadingauditSinglePage = false;
        state.auditSinglePageData = payload;
    },

    auditCodeSnippetError: (state, { payload }) => {
        state.loadingauditCodeSnippet = false;
        state.auditCodeSnippetError = payload;
    },
    auditCodeSnippet: (state, { payload }) => {
        state.loadingauditCodeSnippet = true;
        state.auditCodeSnippetError = '';
    }, 
    auditCodeSnippetSuccess: (state, { payload }) => {
        state.loadingauditCodeSnippet = false;
        state.auditCodeSnippetData = payload;
    },


    languageLevelCheckerError: (state, { payload }) => {
        state.loadinglanguageLevelChecker = false;
        state.languageLevelCheckerError = payload;
    },

    languageLevelChecker: (state, { payload }) => {
        state.loadinglanguageLevelChecker = true;
        state.languageLevelCheckerError = '';
    }, 

    languageLevelCheckerSuccess: (state, { payload }) => {
        state.loadinglanguageLevelChecker = false;
        state.languageLevelCheckerData = payload;
    },



    singlePagesDataError: (state, { payload }) => {
        state.loadingsinglePagesData = false;
        state.singlePagesDataError = payload;
    },

    singlePagesDataI: (state, { payload }) => {
        state.loadingsinglePagesData = true;
        state.singlePagesDataError = '';
    }, 

    singlePagesDataSuccess: (state, { payload }) => {
        state.loadingsinglePagesData = false;
        state.singlePagesData = payload;
    },


    singlePageAuditErrorH: (state, { payload }) => {
        state.loadingsinglePageAudit = false;
        state.singlePageAuditError = payload;
    },

    singlePageAuditH: (state, { payload }) => {
        state.loadingsinglePageAudit = true;
        state.singlePageAuditError = '';
    }, 

    singlePageAuditSuccessH: (state, { payload }) => {
        state.loadingsinglePageAudit = false;
        state.singlePageAudit = payload;
    },






    codeSnippetCheckerError: (state, { payload }) => {
        state.loadingcodeSnippetCheckerData = false;
        state.codeSnippetCheckerDataError = payload;
    },

    codeSnippetCheckerI: (state, { payload }) => {
        state.loadingcodeSnippetCheckerData = true;
        state.codeSnippetCheckerDataError = '';
    }, 

    codeSnippetCheckerSuccess: (state, { payload }) => {
        state.loadingcodeSnippetCheckerData = false;
        state.codeSnippetCheckerData = payload;
    },


    codeSnippetCheckerErrorH: (state, { payload }) => {
        state.loadingcodeSnippetChecker = false;
        state.codeSnippetCheckerError = payload;
    },

    codeSnippetCheckerH: (state, { payload }) => {
        state.loadingcodeSnippetChecker = true;
        state.codeSnippetCheckerError = '';
    }, 

    codeSnippetCheckerSuccessH: (state, { payload }) => {
        state.loadingcodeSnippetChecker = false;
        state.codeSnippetChecker = payload;
    },

  },
});

export default toolsSlice;